<template>
  <div class="popup">
    <van-popup
      v-model="showPopup"
      :overlay="true"
      :close-on-click-overlay="false"
      position="bottom">
      <pupop-title
        title="订单支付"
        @closePopup="closePopup"/>
      <!-- <div class="ljb-x-padding">
        <p class="payTpe ljb-border  double-between">
          <span class="ljb-text title-left">{{ payInfo.title }}</span>
          <span
            class="title-right ljb-text">¥{{ price }}</span>
        </p>
      </div> -->
      <!-- <ljb-item :item="coupon" @chooseFn="chooseCoupon"/> -->
      <div class="ljb-price">
        <span>¥{{ price }}</span>
      </div>
      <pay-list v-model="payType" />
      <div class="btn-pay">
        <normal-btn
          :btn-text="btnText"
          :rights-url="payInfo.rightsUrl"
          @btnClick="commit"/>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'
import PupopTitle from '@/components/title/PupopTitle'
import TextTitle from '@/components/title/TextTitle'
import LjbItem from '@/components/LjbItem'
import PayList from '@/components/pay/payList'
import NormalBtn from '@/components/common/NormalBtn'
import {mapGetters} from 'vuex'
Vue.use(Popup)
export default {
  name: 'PopupPay',
  components: {NormalBtn, PayList, LjbItem, TextTitle, PupopTitle},
  props: {
    payInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }

  },
  data () {
    return {
      showPopup: false,
      payType: '',
      returnUrl: '',
      textTitle: '支付金额',
      // price: '', // 金额
      btnText: '立即支付',
      payOption: {
        // appId: 'wx8077df44c8a9c9a2',
        // nonceStr: 'NkzfUUom1yvd79gH', // 随机串
        // prepay_id: 'wx2021323683607111fb9ad4f31849212900', // prepay_id用等式的格式
        // signType: 'HMAC-SHA256', // 微信签名方式：
        // singn: '0E7FDD63393259723B4B81B100AB2B763E7355B2DDE0BF26981F1D8A380F1988' // 微信签名
      }
    }
  },
  computed: {
    ...mapGetters('Order', ['getCouponId', 'getCouponName', 'getCouponValue', 'getShowPopup', 'getOrderPrice', 'getSelectTime', 'getSelectArea', 'getSelectField', 'getAddInfo']),
    ...mapGetters('User', ['getOpenId', 'getUserInfo']),
    price: function () {
      let discount = 0
      if (this.payInfo.price === '') {
        discount = parseFloat(this.getOrderPrice) - this.getCouponValue
      } else {
        discount = parseFloat(this.payInfo.price) - this.getCouponValue
      }
      if (discount < 0) {
        discount = 0
      }
      return discount
    },
    coupon () {
      console.log('coupon ', this.getCouponName)
      return {
        type: '优惠券',
        value: this.getCouponName,
        showNextArrow: true,
        noBorder: true
      }
    },
    url () {
      let name, path
      if (this.$route.name === 'PayWaiting' || this.$route.path === 'TelDetail') {
        name = window.location.href + '?callBack=paySuccess'
        path = this.$route.path
      } else {
        name = window.location.origin + window.location.pathname + '#/OrderList'
        path = '/OrderList'
      }
      return {
        name,
        path
      }
    }
  },
  mounted () {
    if (this.$route.query.callBack) {
      this.$utils.clearOrderInfo()
      if (this.$route.query.callBack === this.$dataResource.payType.aliPay) {
        this.$toast('支付成功')
      }
    }
    // this.returnUrl = window.location.href + '?callBack=paySuccess'
    if (this.getShowPopup) {
      this.showPopup = true
      this.payInfo.couponId = this.getCouponId
    }
    this.payInfo.coupon = this.getCouponName
    this.coupon.value = this.getCouponName
  },
  methods: {

    closePopup () {
      this.$store.commit('Order/setShowPopup', false)
      this.showPopup = false
      this.$emit('closePopup')
    },
    timerReload: function () {
      // let that = this
      setTimeout(() => {
        // window.location.href = this.url()
        // that.$router.go(0)
        if (this.$route.name === 'PayWaiting' || this.$route.path === 'TelDetail' || this.$route.path === 'MemberRights') {
          window.location.reload()
        } else {
          window.location.href = this.url.name
        }
      }, 1000)
    },
    chooseCoupon: function () {
      this.$store.commit('Order/setShowPopup', true)
      this.$router.push({name: 'ChooseCoupon', params: {id: this.payInfo.productCode}})
    },
    // 支付
    payOrder (orderId) {
      if (this.$utils.isWxgzh()) {
        let that = this
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            that.goMini(orderId)
          } else {
            that.payCom(orderId)
          }
        })
        return
      }
      this.payCom(orderId)
    },
    goMini (orderId) {
      if (this.$utils.getChannel() === 'tb') {
        let token = ''
        if (this.getUserInfo) {
          token = this.getUserInfo.token
        }
        let productName = ''
        if (this.payInfo) {
          productName = this.payInfo.productName || this.payInfo.title
        }

        let openId = this.getOpenId || ''
        let couponId = this.getCouponId || ''
        let that = this

        wx.miniProgram.navigateTo({
          url: '../lawyerPro/lawyerPro?orderId=' + orderId + '&price=' + this.price + '&productCode=' + couponId + '&productName=' + productName + '&token=' + token + '&extra=' + openId,
          // url: '../order/pay/index?orderId=' + orderId + '&price=' + this.price + '&productCode=' + couponId + '&productName=' + productName + '&token=' + token + '&extra=' + openId
          success: (res) => {
            that.$router.replace(that.url.path)
          }
        })
      }
      // wx.navigateToMiniProgram({
      //   appId: 'wx4409ff50defa964a',
      //   path: 'pages/order/orderpay?id=' + orderId,
      //   extraData: {
      //     orderId: orderId
      //   },
      //   envVersion: 'develop',
      //   success (res) {
      //     // 打开成功
      //     alert(res)
      //   },
      //   fail (res) {
      //     alert(res)
      //   }
      // })
    },
    payCom (orderId, isMini) {
      let openid
      if (this.payType === this.$dataResource.payType.wxPay && this.getOpenId) {
        openid = this.getOpenId
      }
      this.$post.payOrder({
        payType: this.payType,
        orderId: orderId,
        couponId: this.getCouponId,
        return_url: this.url.name,
        openid
      }).then((res) => {
        this.$utils.clearOrderInfo()
        if (res.data.payStatus === '2') { // 直接付款成功 刷新页面
          this.timerReload()
          return
        }
        if (this.payType === this.$dataResource.payType.aliPay) {
          const div = document.createElement('div')
          div.innerHTML = res.data.aliPayForm
          document.body.appendChild(div)
          setTimeout(function () {
            document.forms[0].submit()
          }, 500)
        } else if (this.payType === this.$dataResource.payType.wxPay) {
          // wx.chooseWXPay(res)
          if (openid) {
            this.payOption = res.data
            this.onBridgeReady()
            return
          }
          window.location.href = res.data.mweb_url
        }
      })
    },
    jsSdk () {
      console.log(' jsSdk')
      // 判断微信的WeixinJSBridge
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
        }
      } else {
        this.onBridgeReady()
      }
    }, // 支付sdk准备完成
    onBridgeReady () {
      console.log(' onBridgeReady')
      console.log(' onBridgeReady', this.payOption)
      let that = this

      // 触发微信支付
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          appId: this.payOption.appid, // 公众号名称，由商户传入
          timeStamp: this.payOption.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: this.payOption.nonce_str, // 随机串
          package: this.payOption.prepay_id, // prepay_id用等式的格式
          signType: this.payOption.signType, // 微信签名方式：
          paySign: this.payOption.singn // 微信签名
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 支付成功 返回成功页
            that.$utils.clearOrderInfo()
            that.$toast('支付成功')
            // window.location.href = that.url
            that.$router.replace(that.url.path)
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            that.$toast('支付已取消')
          } else {
            that.$toast('支付失败')
          }
        }
      )
    },
    // 创建购买订单
    createOrder () {
      this.$post.createOrder({
        productCode: this.payInfo.productCode
      }).then((res) => {
        this.payOrder(res.data.orderId)
      })
    },
    // 创建见面咨询订单
    createFaceOrder (params) {
      this.$post.faceOrder(params).then(res => {
        this.payOrder(res.data.orderId)
      })
    },
    // 创建发律师函订单
    createLetterOrder (params) {
      this.$post.letterOrder(params).then(res => {
        this.payOrder(res.data.orderId)
      })
    },
    // 创建代打官司订单
    createLawsuitOrder (params) {
      this.$post.lawsuitOrder(params).then(res => {
        this.payOrder(res.data.orderId)
      })
    },
    // 创建律师起草订单
    createDraftOrder (params) {
      this.$post.draftOrder(params).then(res => {
        this.payOrder(res.data.orderId)
      })
    },

    // 选择报价
    chooseQuoted () {
      this.$post.choooseQuoted({
        orderId: this.payInfo.id,
        paperServiceId: this.payInfo.quotedId

      }).then((res) => {
        console.log(res)
        this.payOrder(this.payInfo.id)
      })
    },
    // 提交订单
    commit: function () {
      console.log(this.payInfo)
      let code = this.$dataResource.productCode
      // 待支付
      if (this.payInfo.status === this.$dataResource.orderStatus.unPay) {
        this.payOrder(this.payInfo.id)
        return
      }
      // 文书报价
      if (this.payInfo.payType === 'quoted') {
        this.chooseQuoted(this.payInfo.id)
      }
      // 电话咨询
      if (this.payInfo.productCode === code.phoneCall) {
        this.payOrder(this.payInfo.id)
        return
      }
      // 买会员卡
      if (this.payInfo.payType === 'card') {
        this.createOrder()
        return
      }
      let params = this.payInfo.params
      if (!params) {
        let location = this.getSelectArea ? this.getSelectArea.selectId : ''
        params = {
          userLocation: location,
          consultField: this.getSelectField.selectId,
          expectTime: this.getSelectTime.selected,
          userRemark: this.getAddInfo
        }
      }
      // 见面咨询
      if (this.payInfo.productCode === code.faceConsult) {
        this.createFaceOrder(params)
        return
      }

      // 发律师函
      if (this.payInfo.productCode === code.lawyerLetter) {
        this.createLetterOrder(params)
        return
      }

      // 代打官司
      if (this.payInfo.productCode === code.lawsuit) {
        console.log(12345)
        this.createLawsuitOrder(params)
      }
      console.log(this.payInfo.productCode, code.docDraft)
      // 律师起草
      if (this.payInfo.productCode === code.docDraft) {
        this.createDraftOrder(params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .payTpe{
    background: #fff;
    box-sizing: border-box;
    line-height: 16px;
    padding: $padding 0;
  }
  .title-right{
    color: $price-color;
    font-weight: 600;
  }
  .border-line{
    border-top:10px solid $background-color
  }
  .btn-pay{
    padding: 8px $padding;
  }
  .ljb-price{
    font-size: 30px;
    font-weight: 800;
    color: #333333;
    text-align: center;
    margin:0 10px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay/PopupPay.vue